<template>
  <q-card flat>
    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm">
        <q-input
          outlined
          class="col-2"
          dense
          v-model="FilterString"
          label="机构名称"
          color="primary"
        />
        <q-btn
          color="primary"
          icon="search"
          @click="onLoadData"
          :loading="TgyBaseHospbasicinfoListLoading"
          style="height: 38px;"
        >
          查询
        </q-btn>
        <q-space />
        <!-- <q-btn color="primary" icon="download" style="height: 38px;" @click="onDownload" :loading="WxHomeimageListLoading">
              下载
            </q-btn>
            <q-btn color="primary" style="height: 38px" icon="fas fa-file-excel" :loading="TgyBaseHospbasicinfoListLoading" @click="onExportData">导出</q-btn> -->
        <q-btn
          color="primary"
          style="height: 38px"
          icon="note_add"
          :loading="TgyBaseHospbasicinfoListLoading"
          @click="onAdd"
          >新增</q-btn
        >
      </div>
      <vxe-grid
        v-bind="gridOptions"
        :sort-config="{ multiple: true }"
        :custom-config="{ storage: true }"
        id="custom-config"
        :export-config="gridOptions.tableExport"
        :height="$store.getters.maxPageHeight - 140"
        :loading="TgyBaseHospbasicinfoListLoading"
        highlight-current-row
        size="mini"
      >
        <template #toolbar_buttons id="custom-config"> </template>
        <template #operate="{ row }">
          <vxe-button
            flat
            color="primary"
            icon="fas  fa-edit"
            @click="onEdit(row)"
            >编辑</vxe-button
          >
          <vxe-button
            flat
            color="negative"
            icon="fas fa-trash"
            @click="onDelete(row)"
            >删除</vxe-button
          >
          <vxe-button flat color="negative" @click="onGetHospLogo(row)"
            >获取Logo</vxe-button
          >
          <vxe-button flat color="negative" @click="onIsValid(row)">{{
            row.IsValid == true ? "禁用" : "启用"
          }}</vxe-button>
          <vxe-button flat color="negative" @click="onGetHospQRCode(row)"
            >获取机构码</vxe-button
          >
        </template>
      </vxe-grid>
      <vxe-pager
        perfect
        size="mini"
        :page-sizes="tablePage.pageSizes"
        v-model:current-page="tablePage.currentPage"
        v-model:page-size="tablePage.pageSize"
        :total="tablePage.totalResult"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      >
      </vxe-pager>
    </q-card-section>
  </q-card>

  <q-dialog v-model="tgyBaseHospbasicinfoshowDlg" persistent>
    <BaseHospbasicinfoEdit @onLoadData="onLoadData" />
  </q-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import dlg from "@/config/dialog";
import XEUtils from "xe-utils";
import BaseHospbasicinfoEdit from "./baseHospbasicinfoEdit.vue";
import * as BaseHospbasicinfo from "@/api/gy/base/baseHospbasicinfo.js";
export default {
  components: {
    BaseHospbasicinfoEdit,
  },
  computed: {
    ...mapState("TgyBaseHospbasicinfo", [
      "TgyBaseHospbasicinfoList",
      "TgyBaseHospbasicinfoListLoading",
      "TgyBaseHospbasicinfoEntity",
      "TgyBaseHospbasicinfoShowDlg",
    ]),

    tgyBaseHospbasicinfoshowDlg: {
      get() {
        return this.TgyBaseHospbasicinfoShowDlg;
      },
      set(val) {
        console.log(val);
        this.$store.commit(
          "TgyBaseHospbasicinfo/setTgyBaseHospbasicinfoShowDlg",
          val
        );
      },
    },
  },
  data() {
    return {
      FilterString: "",
      tablePage: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
        pageSizes: [15, 20, 50, 100, 5000],
      },
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        highlightHoverRow: true,
        align: "left",
        toolbarConfig: {
          perfect: true,
          print: true,
          zoom: true,
          custom: true,
          export: true,
          slots: {
            // 自定义工具栏模板
            buttons: "toolbar_buttons",
          },
        },
        //点击编辑必须配置
        // editConfig: {
        //   trigger: "click",
        //   mode: "cell",
        //   activeMethod: () => {
        //     if (this.lockData) return false;
        //     return true;
        //   },
        // },
        tableExport: {},
        columns: [
          { type: "seq", width: 50, align: "center" },
          {
            field: "HospID",
            title: "机构ID",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "HospName",
            title: "医院名称",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "HospMICode",
            title: "医院单位编码",
            sortable: true,
            align: "left",
            width: 160,
          },
          // {
          //   field: "HospAreaCode",
          //   title: "机构区划",
          //   sortable: true,
          //   align: "left",
          //   width: 160,
          // },

          {
            field: "INTERNETIP",
            title: "外网IP",
            sortable: true,
            align: "left",
            width: 200,
          },
          {
            field: "NOTE",
            title: "机构特色",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            field: "IsValid_Name",
            title: "是否启用",
            sortable: true,
            align: "left",
            width: 100,
          },
          {
            field: "FILEPATHNAME",
            title: "机构Logo",
            sortable: true,
            align: "left",
            width: 160,
          },
          {
            title: "操作",
            width: 420,
            slots: { default: "operate" },
            align: "center",
            fixed: "right",
          },
          //   {
          //     field: "CatName",
          //     title: "类别",
          //     sortable: true,
          //     editRender: { name: "input" },//点击编辑必须配置
          //     slots: { edit: "CatName" },//点击编辑必须配置
          //     align: "left",
          //     width: 140,
          //   },
        ],
        // data: this.TgyBaseHospbasicinfoList,
        data: null,
      },
    };
  },
  mounted() {
    this.onLoadData();
  },
  methods: {
    ...mapActions("TgyBaseHospbasicinfo", [
      "actGetTgyBaseHospbasicinfoListByPage",
      "actCreateTgyBaseHospbasicinfo",
      "actEditTgyBaseHospbasicinfoData",
      "actEditTgyBaseHospbasicinfo",
      "actDeleteTgyBaseHospbasicinfo",
    ]),
    onLoadData() {
      this.actGetTgyBaseHospbasicinfoListByPage({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        FilterString: this.FilterString,
        PageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
      })
        .then((res) => {
          this.gridOptions.data = res.Data;
          this.tablePage.totalResult = res.Count;
        })
        .finally(() => {
          this.$store.commit(
            "TgyBaseHospbasicinfo/setTgyBaseHospbasicinfoListLoading",
            false
          );
          //this.TgyBaseHospbasicinfoListLoading = false;
        });
    },
    onAdd() {
      this.actCreateTgyBaseHospbasicinfo({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
      });
    },
    onEdit(e) {
      var obj = {};
      Object.assign(obj, e);
      this.actEditTgyBaseHospbasicinfo(obj);
    },
    onIsValid(row) {
      BaseHospbasicinfo.UpateIsValid({
        Info: row,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
          this.msg.success(res.Message);
        } else {
          dlg.alert(res.Message);
        }
      });
    },
    onDelete(e) {
      this.actDeleteTgyBaseHospbasicinfo({
        HospID: this.$store.getters["appUser/hospID"],
        CUser: this.$store.getters["appUser/userID"],
        Info: e,
      }).then((res) => {
        if (res.Code == 0) {
          this.onLoadData();
        }
      });
    },
    onGetHospQRCode(e) {
      BaseHospbasicinfo.GetHospQRCode({
        Info: e,
      }).then((res) => {
        if (res.Code == 0) {
          window.open(res.Data, "_blank");
        } else {
          dlg.alert(res.Message);
        }
      });
    },
    onGetHospLogo(e) {
      this.$store.commit(
        "TgyBaseHospbasicinfo/setTgyBaseHospbasicinfoListLoading",
        true
      );
      BaseHospbasicinfo.GetHospLogo({
        HospID: e.HospID,
      })
        .then((res) => {
          if (res.Code == 0) {
            this.onLoadData();
            this.msg.success(res.Message);
          } else {
            dlg.alert(res.Message);
          }
        })
        .finally(() => {
          this.$store.commit(
            "TgyBaseHospbasicinfo/setTgyBaseHospbasicinfoListLoading",
            false
          );
        });
    },
    //onExportData:{},
    //需要合计：表头必须添加 :footer-method="footerMethod" 跟 show-footer
    footerMethod({ columns, data }) {
      var list = ["PRIC"]; //需要汇总的字段
      const footerData = [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (list.includes(column.property)) {
            return XEUtils.sum(data, column.property);
          }
          return null;
        }),
      ];
      return footerData;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.onLoadData();
    },
  },
};
</script>
